<script setup lang="ts">
interface IProps {
  to: string
}
const props = defineProps<IProps>()
const { getPathWithLocale } = useLocalizedPath()
const localizedTo = computed(() => getPathWithLocale(props.to))
</script>

<template>
  <SheetClose as-child>
    <NuxtLink :to="localizedTo" class="hover:underline">
      <slot />
    </NuxtLink>
  </SheetClose>
</template>
